"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("reactstrap/lib/Card"));

var _CardBody = _interopRequireDefault(require("reactstrap/lib/CardBody"));

var _CardHeader = _interopRequireDefault(require("reactstrap/lib/CardHeader"));

var _CardFooter = _interopRequireDefault(require("reactstrap/lib/CardFooter"));

var _CardTitle = _interopRequireDefault(require("reactstrap/lib/CardTitle"));

var _CardSubtitle = _interopRequireDefault(require("reactstrap/lib/CardSubtitle"));

var _Row = _interopRequireDefault(require("reactstrap/lib/Row"));

var _Col = _interopRequireDefault(require("reactstrap/lib/Col"));

var _Collapse = _interopRequireDefault(require("reactstrap/lib/Collapse"));

var _WarningYellowOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/WarningYellowOutline"));

var _messageBox = _interopRequireDefault(require("../messageBox"));

var _loader = _interopRequireDefault(require("../loader"));

require("./card.css");

var _icon = _interopRequireDefault(require("../icon/icon"));

var _icons = require("../lib/icons");

var _utils = require("../lib/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Card = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Card, _React$Component);

  var _super = _createSuper(Card);

  function Card(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Card);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleCollapse", function (e) {
      if (e) {
        e.stopPropagation();
      }

      var isCollapsed = _this.state.isCollapsed;
      var _this$props = _this.props,
          onCollapse = _this$props.onCollapse,
          onExpand = _this$props.onExpand;

      _this.setState({
        isCollapsed: !isCollapsed
      }, function () {
        (0, _setTimeout2["default"])(function () {
          var newIsCollapsed = _this.state.isCollapsed;

          if (newIsCollapsed) {
            onCollapse();
          } else {
            onExpand();
          }
        }, 300);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCardTitleContainerClick", function (e) {
      var classes = e.target.classList; // if the click called on something other than card title and collapse toggle icon
      // then simple ignore it

      if (!classes.contains("oui-card-title") && !classes.contains("oui-card-collapse-toggler")) {
        return;
      }

      _this.toggleCollapse(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderTitle", function () {
      var _this$props2 = _this.props,
          title = _this$props2.title,
          collapsible = _this$props2.collapsible;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-card-title-inner",
        onClick: function onClick(e) {
          if (collapsible) {
            _this.onCardTitleContainerClick(e);
          }
        },
        "aria-hidden": "true"
      }, (0, _utils.isString)(title) ? /*#__PURE__*/_react["default"].createElement(Card.Title, {
        title: title
      }) : (0, _utils.isFunction)(title) ? title() : null);
    });
    _this.state = {
      isCollapsed: props.collapsedByDefault
    };
    return _this;
  }

  (0, _createClass2["default"])(Card, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          subtitle = _this$props3.subtitle,
          titleAction = _this$props3.titleAction;

      if (!title && (subtitle || titleAction)) {
        // eslint-disable-next-line no-console
        console.warn("Card title is mandatory while providing subtitle and/or title actions");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          title = _this$props4.title,
          titleAction = _this$props4.titleAction,
          dataTestId = _this$props4.dataTestId,
          fullHeight = _this$props4.fullHeight,
          collapsible = _this$props4.collapsible,
          subtitle = _this$props4.subtitle,
          body = _this$props4.body,
          footer = _this$props4.footer,
          onClick = _this$props4.onClick,
          disabled = _this$props4.disabled,
          isLoading = _this$props4.isLoading,
          isError = _this$props4.isError;
      var isCollapsed = this.state.isCollapsed;
      var renderOnlyBody = !title;

      var cardBodyContent = /*#__PURE__*/_react["default"].createElement(_CardBody["default"], {
        className: renderOnlyBody ? "oui-pt-2" : ""
      }, isError ? /*#__PURE__*/_react["default"].createElement(_messageBox["default"], {
        icon: /*#__PURE__*/_react["default"].createElement(_WarningYellowOutline["default"], null),
        secondaryText: "Error loading data"
      }) : null, (0, _utils.isFunction)(body) && !isError ? body() : null);

      cardBodyContent = isLoading ? /*#__PURE__*/_react["default"].createElement(_loader["default"], {
        isLoading: true,
        className: "oui-card-loader"
      }, cardBodyContent) : cardBodyContent;
      return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props, fullHeight ? "oui-mnh-100" : null, collapsible ? isCollapsed ? "oui-card-collapsible oui-card-collapsed" : "oui-card-collapsible oui-card-expanded" : "", (0, _utils.isFunction)(onClick) && "oui-hoverable"),
        onClick: onClick
      }, disabled && /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-disable-overlay"
      }), title && /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
        className: "oui-bg-white oui-bb-0"
      }, (0, _utils.isFunction)(titleAction) || collapsible ? /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        className: "oui-card-title-container"
      }, this.renderTitle(), subtitle && (0, _utils.isString)(title) ? /*#__PURE__*/_react["default"].createElement(_CardSubtitle["default"], {
        tag: "h6",
        className: "text-muted"
      }, subtitle) : null), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        className: "oui-col-auto oui-card-title-action"
      }, (0, _utils.isFunction)(titleAction) ? titleAction() : null, collapsible ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        src: _icons.ArrowRight,
        width: "12px",
        height: "12px",
        clickable: true,
        onClick: this.toggleCollapse,
        className: (0, _utils.gatherClasses)(null, "oui-card-collapse-toggler")
      }) : null)) :
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-fragments
      _react["default"].createElement(_react["default"].Fragment, null, this.renderTitle(), subtitle && (0, _utils.isString)(title) ? /*#__PURE__*/_react["default"].createElement(_CardSubtitle["default"], {
        tag: "h6",
        className: "text-muted"
      }, subtitle) : null)), collapsible ? /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
        isOpen: !isCollapsed
      }, cardBodyContent, (0, _utils.isFunction)(footer) ? /*#__PURE__*/_react["default"].createElement(_CardFooter["default"], null, footer()) : null) :
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-fragments
      _react["default"].createElement(_react["default"].Fragment, null, cardBodyContent, (0, _utils.isFunction)(footer) ? /*#__PURE__*/_react["default"].createElement(_CardFooter["default"], null, footer()) : null));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (!props.title && (props.subtitle || props.titleAction)) {
        // eslint-disable-next-line no-console
        console.warn("Card title is mandatory while providing subtitle and/or title actions");
      }

      return null;
    }
  }]);
  return Card;
}(_react["default"].Component);

Card.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  subtitle: _propTypes["default"].string,
  body: _propTypes["default"].func.isRequired,
  fullHeight: _propTypes["default"].bool,
  titleAction: _propTypes["default"].func,
  collapsible: _propTypes["default"].bool,
  collapsedByDefault: _propTypes["default"].bool,
  onCollapse: _propTypes["default"].func,
  onExpand: _propTypes["default"].func,
  footer: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  isError: _propTypes["default"].bool
};
Card.defaultProps = {
  fullHeight: false,
  collapsible: false,
  collapsedByDefault: false,
  onCollapse: function onCollapse() {},
  onExpand: function onExpand() {},
  dataTestId: "orion-card",
  onClick: null,
  disabled: false,
  isLoading: false,
  isError: false
};
Card.displayName = "OrionCard";

Card.Title = function CTitle(props) {
  var title = props.title;
  return /*#__PURE__*/_react["default"].createElement(_CardTitle["default"], {
    tag: "h6",
    className: (0, _utils.gatherClasses)(props, "mb-0")
  }, title);
};

Card.Title.displayName = "OrionCardTitle";
Card.Title.propTypes = {
  title: _propTypes["default"].string
};
Card.Title.defaultProps = {
  title: ""
};
var _default = Card;
exports["default"] = _default;